const API_BASE_URL = (import.meta.env.VITE_AXON_API_BASE_URL || "https://api.axonleads.ru").replace(/\/$/, "");
const PERIODS = new Set(["7d", "30d", "90d"]);

export class AnalyticsApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "AnalyticsApiError";
    Object.assign(this, details);
  }
}
export async function fetchAnalyticsOverview(idToken, period = "30d") {
  if (!PERIODS.has(period)) throw new AnalyticsApiError("Неизвестный период аналитики.");
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/v1/analytics/overview?period=${period}`, {
      headers: { Authorization: `Bearer ${idToken}` },
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new AnalyticsApiError("Нет связи с аналитикой. Проверьте интернет и повторите.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const apiError = payload?.error || {};
    const detail = typeof payload?.detail === "string" ? payload.detail : null;
    throw new AnalyticsApiError(
      typeof apiError.message === "string"
        ? apiError.message
        : detail || "Не получилось собрать аналитику.",
      { status: response.status, code: apiError.code },
    );
  }
  return payload;
}

export async function recordProductEvent(idToken, input) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/v1/product-events`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(input),
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    return null;
  }
  if (!response.ok) return null;
  return response.json().catch(() => null);
}
